module.exports = __webpack_public_path__ + "img/zigzag.07aa9762.png";